import {needAuth} from "../../instance/Instance";
import {AxiosError} from "axios";

async function getIntroductionList(search, pageable) {
    console.log(">> 자산도입관리 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {

            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return await needAuth.post('/lifecycle/introduction?'+pageStr,search);
    }catch (error){
        return error;
    }
}

async function removeIntroductions(ids) {
    try {
        return await needAuth.put('/lifecycle/introduction/delete', ids);
    }catch (error){
        return error;
    }
}

async function getIntroduction(id) {
    try{
        return  await needAuth.get('/lifecycle/introduction/'+id);
    }catch (error){
        return error;
    }
}

async function saveIntroduction(introduction, files) {
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });
    
    formData.append(
        "introductionRequestDto",
        new Blob([JSON.stringify(introduction)], { type: "application/json" })
    );

    try {
        return await needAuth.post(`/lifecycle/introduction/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
    }catch (error){
        return error;
    }
}

async function updateIntroduction(data) {
    try {
        return await needAuth.put(`/lifecycle/introduction/update`, data)
    }catch (error){
        return error;
    }
}

const updateIntroductionForVerification = async (data) => {
    try {
        return await needAuth.put(`/lifecycle/introduction/verification`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const assetIntroduction = async (data) => {
    try {
        return await needAuth.post(`/lifecycle/introduction/introduct`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

export {getIntroductionList, removeIntroductions, saveIntroduction, getIntroduction, updateIntroduction, updateIntroductionForVerification, assetIntroduction};